import React from 'react';

function LocalLoaderLight({message}) {
    return (
        <>
            <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-gray-100 mx-auto my-auto"></div>
            <p className={'font-bold mt-8 text-dutch_white-200'}>{message}</p>
        </>
    );
}

export default LocalLoaderLight;